export default __webpack_public_path__ + "static/013-c72b4896e1a95a9052fad44d192f3796.jpg";